<script lang="ts">
	import Badge from '$lib/atoms/Badge.svelte'
	import {
		getBackgroundColorString,
		getColorString
	} from '$lib/analytics/utils/analysisScaleConfig'

	interface Props {
		valueString?: string
		value?: number
		ordinal: number
		maxOrdinal: number
		unit?: string
		description?: string
		operator?: string
	}

	let {
		valueString,
		value,
		ordinal,
		maxOrdinal,
		unit,
		description,
		operator,
		...restProps
	}: Props = $props()

	const color = $derived(getColorString(maxOrdinal, ordinal))
	const backgroundColor = $derived(getBackgroundColorString(maxOrdinal, ordinal))

	const text = $derived(
		[operator ?? '', valueString ?? value ?? '', unit ?? '', description ?? ''].join(' ')
	)
</script>

<Badge {text} {color} {backgroundColor} {...restProps}></Badge>
